import React, { useMemo } from "react";
import { Radar } from "react-chartjs-2";
import { Box } from "@material-ui/core";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {
  RADAR_CHART_HEIGHT,
  radarChartLayoutOptions
} from "./radarChartConfig";

const OverallPerformanceChart = ({ data }) => {
  const { t } = useTranslation();
  const options = useMemo(
    () => ({
      ...radarChartLayoutOptions,
      tooltips: {
        mode: "index",
        intersect: false,
        callbacks: {
          title(tooltipItems, chartData) {
            if (!tooltipItems || !tooltipItems.length) {
              return "";
            }
            const idx = tooltipItems[0].index;
            return chartData.labels[idx] != null
              ? String(chartData.labels[idx])
              : "";
          },
          label(tooltipItem, chartData) {
            const ds = chartData.datasets[tooltipItem.datasetIndex];
            const name = ds && ds.label ? ds.label : "";
            const v =
              tooltipItem.yLabel != null
                ? tooltipItem.yLabel
                : tooltipItem.value;
            return name
              ? t("student.charts.tooltipValue", { name, value: v })
              : String(v);
          }
        }
      }
    }),
    [t]
  );

  return (
    <Box width="100%" style={{ height: RADAR_CHART_HEIGHT }}>
      <Radar data={data} options={options} height={RADAR_CHART_HEIGHT} />
    </Box>
  );
};

OverallPerformanceChart.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired
};

export default OverallPerformanceChart;
